import { Redirect } from 'react-router-dom'
import './NoMatch.css'

const NoMatch = () => {
  return <Redirect to='/' />
}

export default NoMatch
